import React from "react";
import PropTypes from "prop-types";
import { AlertTriangle } from "lucide-react";

import { getButtonClassName, surfaceStyles } from "./ui/styles";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state to display fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught an error", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main
          id="main-content"
          className="grid min-h-screen place-items-center bg-background px-4 py-8 text-text"
        >
          <section
            className={`${surfaceStyles.hero} w-full max-w-xl px-6 py-10 text-center sm:px-10`}
            role="alert"
          >
            <span className="mx-auto flex h-12 w-12 items-center justify-center shape-pill bg-red-500/10 text-red-500 dark:text-red-400">
              <AlertTriangle className="h-6 w-6" aria-hidden="true" />
            </span>
            <h1 className="mt-5 text-2xl font-semibold">Noe gikk galt</h1>
            <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-textSecondary">
              Vi klarte ikke å vise siden. Last den inn på nytt, eller gå
              tilbake til oppgavene.
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-2">
              <button
                type="button"
                onClick={() => window.location.reload()}
                className={getButtonClassName({
                  variant: "primary",
                  size: "md",
                })}
              >
                Last inn på nytt
              </button>
              <a
                href="/"
                className={getButtonClassName({
                  variant: "secondary",
                  size: "md",
                })}
              >
                Gå til oppgavene
              </a>
            </div>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};
